import { API } from "@/services"

export const CENTRAL_POINTS_ENDPOINTS = {
  list(params={}){
    return API.Axios.central_point.v1.request({
      url: `central-points`,
      method: 'GET',
      params,
    })
  },
  add(data={}){
    return API.Axios.central_point.v1.request({
      url: `central-points`,
      method: 'POST',
      data,
    })
  },
  remove(id='',data={}){
    return API.Axios.central_point.v1.request({
      url: `central-points/${id}`,
      method: 'DELETE',
      data,
    })
  },
  update(id='',data={}){
    return API.Axios.central_point.v1.request({
      url: `central-points/${id}`,
      method: 'PUT',
      data,
    })
  },
  get(id='',params={}){
    return API.Axios.central_point.v1.request({
      url: `central-points/${id}`,
      method: 'GET',
      params,
    })
  },
}